module.exports = __webpack_public_path__ + "static/media/banner1.2cd78984.jpg";